// --- Views
import ModelSelect from '@/views/build-and-price/ModelSelect.vue';
import TrimSelect from '@/views/build-and-price/TrimSelect.vue';
import TrimDetails from '@/views/build-and-price/TrimDetails.vue';
import ColoursSelect from '@/views/build-and-price/ColoursSelect.vue';
import PaymentCalculator from '@/views/shared/PaymentCalculator.vue';
import ErrorView from '@/views/shared/ErrorPageV2.vue';
import EmptyRouterView from '@/views/shared/EmptyRouterView2.vue';

// Sub routes
import CreditSubRoute from '@/router/mobile/shared/credit';
import TradeInSubRoute from '@/router/mobile/shared/trade-in';
import FinanceSubRoute from '@/router/mobile/shared/finance';
import ContactDealerRoute from '@/router/mobile/build-and-price/contact-dealer';

export default [
  {
    path: '',
    redirect: { path: 'model-select' },
  },
  {
    path: 'model-select',
    component: ModelSelect,
    meta: {
      headerIcon: false,
      hasNext: true,
      nextRoutePath: 'trim-select',
      headerStyleClasses: 'mb-0',
      isConfigFlow: true,
    },
  },
  {
    path: 'trim-select',
    component: TrimSelect,
    meta: {
      headerIcon: 'back',
      hasNext: true,
      nextRoutePath: 'colours-select',
      headerStyleClasses: 'mb-0',
      isConfigFlow: true,
    },
  },
  {
    path: 'trim-details',
    component: TrimDetails,
    meta: {
      headerIcon: 'back',
      hideHeaderCloseButton: true,
      headerStyleClasses: 'mb-0',
      isConfigFlow: false,
    },
  },
  {
    path: 'colours-select',
    component: ColoursSelect,
    meta: {
      headerIcon: 'back',
      hasNext: true,
      nextRoutePath: 'payment-summary',
      headerStyleClasses: 'mb-0',
      isConfigFlow: true,
    },
  },
  {
    path: 'payment-summary',
    component: PaymentCalculator,
    meta: {
      headerIcon: 'back',
      hasNext: false,
      headerStyleClasses: 'mb-0',
      isConfigFlow: true,
    },
  },
  {
    path: 'credit',
    component: EmptyRouterView,
    children: CreditSubRoute,
    redirect: { path: 'credit/select-credit-range' },
  },
  {
    path: 'trade-in',
    component: EmptyRouterView,
    children: TradeInSubRoute,
    redirect: { path: 'trade-in/vehicle-autocomplete' },
  },
  {
    path: 'finance',
    component: EmptyRouterView,
    children: FinanceSubRoute,
    redirect: { path: 'finance/finance-intro' },
  },
  {
    path: 'contact-dealer',
    component: EmptyRouterView,
    children: ContactDealerRoute,
    redirect: { path: 'contact-dealer/contact-dealer-form' },
  },
  {
    path: 'error',
    component: ErrorView,
    meta: {
      headerIcon: false,
      navInfo: false,
      hasNext: true,
      nextRoutePath: 'payment-summary',
      errorPayload: null,
    },
  },
  {
    path: 'lead-expired',
    component: ErrorView,
    meta: {
      headerIcon: false,
      navInfo: false,
      hasNext: false,
      errorPayload: {
        errorType: 'expired',
      },
    },
  },
  {
    path: '*',
    redirect: { path: 'error' },
  },
];
